import React from 'react';


const ScopeTags = ({content,width = "w-auto"}) => {
  return (
   <div className={`h-[35px] ${width} bg-[#EBF4F9] border border-[#4D9CCC] 
      rounded-[10px] text-[#28668B] font-semibold flex justify-center items-center px-3`}>
  {content}
</div>
  );
};

export default ScopeTags;
